import { render, staticRenderFns } from "./SizeSelectorCommon.vue?vue&type=template&id=0f94a6ce&scoped=true&"
import script from "./SizeSelectorCommon.vue?vue&type=script&lang=js&"
export * from "./SizeSelectorCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94a6ce",
  null
  
)

export default component.exports